import * as React from "react";

export class EventInfo extends React.Component<{
    modifier?: string;
    handler?: React.MouseEventHandler;
    link: string
}, {}> {
    render() {
        let clsMdf = this.props.modifier ? ` rj-superbanner__event-information-row--${this.props.modifier}` : "";
        let dataUat = this.props.modifier ? `superbanner-event-information-row-${this.props.modifier}` : "superbanner-event-information-row";
        return (
            <a href={this.props.link} className={`rj-superbanner__event-information-link`} onClick={this.props.handler}>
                <div className={`rj-superbanner__event-information-row${clsMdf}`} data-uat={dataUat}>
                    {this.props.children}
                </div>
            </a>
        )
    }
}